import React, { useContext, useEffect, useState } from 'react';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import { mixpanelEventTrack } from '../../services/mixpanel';
import Rating from './Rating';
import getBillData from '../../utils/getBillData';
import ReceiptList from '../Booker/ReceiptList';
import { ReactComponent as ArrowIcon } from '../../assets/img/arrow.svg';
import { ReactComponent as CloseIcon } from '../../assets/img/close.svg';
import '../../assets/styles/receipt.sass';
import '../../assets/styles/ride-history.sass';

const RideDetailsReceipt = ({ closeRideHistoryHandler }) => {
  const context = useContext(BookerContext);
  const { state: { rideDetailsHistory, rideDetailsReceipt, isWebBooker } = {}, updateRideDetailsReceipt } = context;
  const { togglePopup } = useContext(BookerShortContext);

  const [bill, setBill] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!rideDetailsHistory) return;
    getBillData({ rideId: rideDetailsReceipt.ride_id, setLoading, setBill });
  }, []);

  const handleSendReceipt = () => {
    return FetchService.getWebApiResource(
      urlService.sendEReceipt(rideDetailsReceipt.ride_id, rideDetailsReceipt.rider_email),
    )
      .then(response => {
        setLoading(false);
        mixpanelEventTrack(isWebBooker ? 'receiptSentWebBook' : 'receiptSent');
        togglePopup(true, 'eReceipt');
      })
      .catch(error => {
        setLoading(false);
        togglePopup(true, 'eReceiptError');
      });
  };

  const onBackHandler = () => {
    updateRideDetailsReceipt(null);
  };

  const rideParams = [
    {
      id: 'confirmation',
      label: `Confirmation:`,
      value: rideDetailsReceipt.confirmation_number,
    },
    {
      id: 'fleet',
      label: `Fleet:`,
      value: '-',
    },
    {
      id: 'driver',
      label: `Driver:`,
      value: rideDetailsReceipt.driver_name || '-',
    },
    {
      id: 'vehicle',
      label: `Vehicle:`,
      value: rideDetailsReceipt.vehicle_number || '-',
    },
    {
      id: 'date',
      label: `Date:`,
      value: rideDetailsReceipt.pickup_time_local,
    },
  ];

  return (
    <div className="form-group ride-details-receipt-container receipt-container">
      <div className="details-container">
        <div className="details-header">
          <ArrowIcon onClick={onBackHandler} className="arrow-history" />
          <div className="title">Receipt</div>
          <CloseIcon className="details-hide-icon" onClick={closeRideHistoryHandler} />
        </div>
        <div className="total">{rideDetailsReceipt.total_formatted}</div>

        {!loading && Object.keys(bill).length && (
          <>
            <ReceiptList bill={bill} />
            <div className="total-container">
              <div className="total-label">Total:</div>
              <div className="total-value">${Number(bill.total / 100).toFixed(2)}</div>
            </div>

            <div className="receipt-breakdown-container receipt-breakdown-history-container">
              {rideParams.map(item => (
                <div className="receipt-breakdown" key={item.id}>
                  <div className="receipt-label">{item.label}</div>
                  <div className="receipt-value">{item.value}</div>
                </div>
              ))}
            </div>

            <Rating rateLevelAmount={5} rating={rideDetailsReceipt.rating} isFullStar={true} />
          </>
        )}
      </div>
      <div className="send-receipt-container">
        <span onClick={handleSendReceipt}>Resend Receipt</span>
      </div>
    </div>
  );
};

export default RideDetailsReceipt;
